// escape all special characters in a string for use in regex
// no built-in method for escape in javascript
var escapeRegex = function (str) {
    return str.replace(/[/\-\\^$*+?.()|[\]{}]/g, "$&"); // $& means the whole matched string
};
export var getIsOnPath = function (routes, path) {
    return routes.some(function (route) {
        // use the route to build a Regex expression
        var routeFormatted = route
            .split('/')
            .filter(function (s) { return s.length > 0; })
            .map(function (s) {
            var sRegexExpression = '';
            if (s.startsWith(':') && s.endsWith('?')) {
                // optional dynamic parameter in the url
                sRegexExpression = '[/]?[[a-z0-9-_]*]?';
            }
            else if (s.startsWith(':')) {
                // route is a parameter, accept ANY of the character within the square bracket
                sRegexExpression = '/[a-z0-9-_]+';
            }
            else {
                sRegexExpression = "/" + s;
            }
            return sRegexExpression;
        })
            .join('');
        return new RegExp(escapeRegex("^" + routeFormatted + "$")).test(path);
    });
};
